import { getPictureBySize } from "base/shared/Utils";

export const getUserPictureBySize = getPictureBySize("user");
